<template>
    <div>
        <v-hover
            v-slot="{ hover }"
        >
            <v-card 
                :elevation="hover ? 6 : 1"
                class="mx-auto custom-card" 
                variant="outlined" 
                style="background-color: white;"
            >
                <v-card-text>
                    <v-row>
                        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            <v-row dense>
                                <!-- Codigo e datas -->
                                <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                        <span>
                                            <v-chip
                                                color="blue"
                                                label
                                                text-color="white"
                                                class="font-weight-medium text-h7"
                                            >
                                            COD: {{ item.codigo }} 
                                            </v-chip>   
                                        </span>
                                        <span class="ml-2">
                                            <v-chip
                                                :color="item.status | statusFac"
                                                label
                                                text-color="black"
                                                class="font-weight-medium text-h7"
                                            >
                                                {{ item.status }}
                                            </v-chip> 
                                        </span>
                                        <span class="ml-2 text-h7 black--text font-weight-medium">
                                            {{ item.finalidade }}
                                        </span>   
                                </v-col> 

                                <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                                    <span class="text-h7 black--text font-weight-medium">  
                                        DT CAD.: 
                                        <span v-if="item.created_at"> {{ item.created_at }}</span>
                                    </span>
                                    <span class="ml-2 text-h7 black--text font-weight-medium">  
                                        DT AT.: 
                                        <span v-if="item.updated_at"> {{ item.updated_at }}</span>
                                    </span>
                                </v-col>        
                            </v-row>
                            <!-- Fim codigo e datas -->


                            <!-- colaboradores -->
                            <v-row dense>
                                <v-col class="font-weight-light black--text" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                     Colaboradores: 
                                    <span v-for="(colab, index) in item.colaborators" :key="colab.id">
                                        {{ colab.name }}
                                        <span v-if="(index + 1) < item.colaborators.length">, </span>
                                    </span>
                                </v-col>    
                            </v-row>
                            <!-- fim colaboradores -->

                            <!-- valores -->
                            <v-row dense>
                                <v-col cols="auto" v-if="item.nome" :class="$vuetify.breakpoint.smAndDown ? 'text-subtitle-2 black--text' : 'text-h6 black--text'">
                                    Nome: {{ item.nome }}
                                </v-col> 
                            </v-row>
                            <!-- fim valores -->


                            <div class="mt-1 mb-1">
                                <v-row
                                    dense
                                >
                                    <v-col cols="auto" class="font-weight-light black--text">
                                        Como conheceu: {{ item.como_conheceu }}
                                    </v-col>
                                    <v-col cols="auto" class="font-weight-light black--text">
                                        Classificação: {{ item.classificacao }}
                                    </v-col>
                                    <v-spacer/>

                                    <v-col cols="auto">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn 
                                                    v-bind="attrs" v-on="on" 
                                                    :class="$css_button" 
                                                    :small="$vuetify.breakpoint.smAndDown" 
                                                    depressed 
                                                    outlined 
                                                    @click.prevent="setDialog('showitem',item)"
                                                >
                                                    <v-icon left>mdi-eye</v-icon> Ficha
                                                </v-btn>
                                            </template>
                                            <span>Visualizar Ficha</span>
                                        </v-tooltip>
                                    </v-col> 
                                    <v-col cols="auto" 
                                        v-if="
                                            item.status == 'Pendente' 
                                            ? can('Edita imóvel pendente', { item: item }) 
                                            : can('Edita imóvel ativo da carteira', { item: item })"
                                    >
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn v-if="item.status != 'Pendente'" 
                                                    v-bind="attrs" v-on="on" 
                                                    :class="$css_button"
                                                    :small="$vuetify.breakpoint.smAndDown"  
                                                    depressed 
                                                    outlined 
                                                    @click.prevent="alertPendente()"
                                                >
                                                    <v-icon left>mdi-pencil</v-icon> Editar
                                                </v-btn>

                                                <v-btn v-if="item.status == 'Pendente'" 
                                                    v-bind="attrs" v-on="on" 
                                                    :class="$css_button" 
                                                    :small="$vuetify.breakpoint.smAndDown" 
                                                    depressed 
                                                    outlined
                                                    @click.prevent="editItem(item.id)"
                                                >
                                                    <v-icon left>mdi-pencil</v-icon> Editar
                                                </v-btn>
                                            </template>
                                            <span>Edita Ficha</span>
                                        </v-tooltip>
                                    </v-col>
                                </v-row>
                            </div>    

                        </v-col>
                    </v-row>
                </v-card-text>    
            </v-card>
        </v-hover>  



        <v-dialog
            v-model="dialog"
            persistent
            max-width="500"
        >
            <v-card>
                <v-card-title :class="$vuetify.breakpoint.smAndDown ? 'text-subtitle-1 font-weight-medium d-print-none' : 'text-h5 d-print-none'">
                    O status será alterado para Pendente.
                </v-card-title>
                    <v-card-text>Após concluir a edição não esqueça de alterar o status caso necessário. Caso não tenha acesso de alteração de status solicite junto a sua gerência.</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="green darken-1"
                        text
                        @click="alertPendente()"
                    >
                        Fechar
                    </v-btn>
                    <v-btn
                        color="green darken-1"
                        text
                        @click="setPendente(item.id)"
                    >
                        Prosseguir
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


        <!-- Dialog -->
        <v-dialog 
            class="d-print-none"
            v-model="dialog_request" 
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
        >
            <v-system-bar
                dark
                color="primary"
                height="10px"
                class="d-print-none"
            >    
            </v-system-bar>    

            <v-card class="d-print-none" >
                <v-card-title :class="$vuetify.breakpoint.smAndDown ? 'text-subtitle-1 font-weight-medium d-print-none' : 'text-h5 d-print-none'" >

                    <span>
                        Solicitação de alteração
                    </span>
                    
                    <span v-if="item.codigo" class="ml-2">- Código {{ item.codigo }} </span>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="openCloseDialog()">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-divider></v-divider>
                <v-container>
                    <v-row>
                        <v-col cols="12">
                            <store-user-request-component :object="user_requests"></store-user-request-component>
                        </v-col>
                    </v-row>     
                </v-container>
            </v-card>   
        </v-dialog>
        <!-- End Dialog -->


    </div>
</template>


<script>
import { mapGetters } from 'vuex';

export default {
    components: {
       
    },

    computed: {
        ...mapGetters('permissions', ['can']),
        
        me () {
            return this.$store.state.auth.me
        },
    }, 

    props: {
        item: {
            type: Object, // Adicione o tipo
            required: true, // Corrigido: "required" em vez de "require"
            default: () => {} // Adicione um valor padrão para arrays
        },
    },

    data () {
        return {
            dialog: false,
            dialog_request: false,
            user_requests: {
                model: 'properties',
                item_id: '',
                subject: 'Solicitação de alteração',
                object: {}
            },
        }
    },

    methods: {
        setDialog(module, item){
            const params = {};
            params.module = module;
            params.item = item; 
            this.$emit('callSetDialog', params);
        },

        alertPendente(){
            this.dialog = !this.dialog;
        }, 
        
        openCloseDialog(){
            this.user_requests.item_id = null;
            this.user_requests.object = null;
            if(!this.dialog_request){
                this.user_requests.item_id = this.item.id;
                this.user_requests.object = this.item;
            }
            this.dialog_request = !this.dialog_request;
        },

        
        editItem(id){
            this.$router.push({
                name: 'admin.facs2.edit',
                params: { uuid: id }
            });
        }
    }
}
</script>